import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 14 14",
  stroke: "white"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M9.08626 13.25H4.91992",
      fill: "none",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M6.25 1.00012L6.25195 13.2501L7.75195 13.2499L7.75 0.99988L6.25 1.00012Z",
      stroke: "none"
    }, null, -1),
    _createElementVNode("path", {
      d: "M12.5 3C12.5 2.58128 12.5 2.37191 12.4367 2.18845C12.305 1.80684 11.9552 1.4781 11.5211 1.32817C11.3124 1.25609 11.0767 1.23565 10.6052 1.19477C9.49034 1.09812 8.09008 1 7 1C5.90992 1 4.50966 1.09812 3.39484 1.19477C2.92332 1.23565 2.68756 1.25609 2.47889 1.32817C2.04485 1.4781 1.69498 1.80684 1.56331 2.18845C1.5 2.37191 1.5 2.58128 1.5 3",
      fill: "none",
      "stroke-width": "1.5",
      "stroke-linecap": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }